import { ONBOARDING_RETAIL_HYBRID_CODES } from '../constants'

export const checkIsOnboardingRetailHybrid = (specializationCode: string) => {
  return ONBOARDING_RETAIL_HYBRID_CODES.includes(specializationCode)
}
